import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-content prefix" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h5", { class: "title" }, " 참여신청 "),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 1. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, " 신청이 완료되었는지 어떻게 확인하나요? "),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
            /*#__PURE__*/_createTextVNode(" 신청이 완료되면 등록하신 핸드폰 번호로 카카오톡 알림 메시지가 발송되며, "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode("테라사이클 내 '마이페이지'에서 확인 가능합니다. ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 2. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "신청자 정보를 수정하고 싶습니다."),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
            /*#__PURE__*/_createTextVNode(" 테라사이클 사이트 내 로그인 후 '마이페이지'에서 수정 가능합니다"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode("※ 등록된 주소지로 수거 및 리워드 발송이 진행되므로 정확한 주소 입력을 부탁드립니다. ")
          ])
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-content prefix" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h5", { class: "title" }, " 수거신청 "),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 1. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "박스 수거 신청은 어떻게 하나요?"),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 해당 수거 기간 내에 테라사이클(https://www.terracycle-kr.com/) 내 마이페이지에서 수거 신청 해주시면 됩니다. "),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 수거 기간 내 분리배출 하기로 약속해주신 종이팩 수를 채워 보내 주셔야만 리워드 제공이 가능한 점 참고 부탁드립니다. (30개 OR 100개) ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 2. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "수거 시 택배 비용은 본인 부담인가요?"),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
            /*#__PURE__*/_createTextVNode(" 캡틴쓱 시즌2 : 팩체인저 캠페인에 참가하신 팩체인저 분들의 박스는 본인 부담 없이"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 무료로 수거해 드립니다. ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 3. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "캠페인 기간 내에 목표 개수만큼 모으지 못하면 어떡하나요?"),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
            /*#__PURE__*/_createTextVNode(" 사전에 공지된 캠페인 기간 내에 목표 개수를 다 채우지 못하실 경우 수거는 가능하나,"),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" 리워드는 제공되지 않습니다. ")
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 4. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "캠페인 기간이 지났는데 수거 신청해도 될까요?"),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, " 수거 신청은 사전에 공지된 수거 기간에만 가능하니 미리 일정을 확인해 주시기 바랍니다. ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ssg-dialog-content" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h5", { class: "title" }, " 수거프로그램 리워드 "),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 1. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, "아래의 분리배출 과정을 올바른 방법으로 종이팩 박스를 보내 주신 분들에게 선물로 드립니다."),
          /*#__PURE__*/_createElementVNode("p", null, " (1) 내용물을 비우고 깨끗하게 헹구기 "),
          /*#__PURE__*/_createElementVNode("p", null, " (2) 팩 말린 후 펼치기 "),
          /*#__PURE__*/_createElementVNode("p", null, " (3) 박스 내, 일반팩 / 멸균팩 구분하여 담기 "),
          /*#__PURE__*/_createElementVNode("p", null, " (4) 테라사이클로 종이팩 박스 보내기 "),
          /*#__PURE__*/_createElementVNode("p", null, " ※ 수거 품목에 맞지 않은 내용물을 보내실 경우 개별 안내 없이 리워드 수령 대상에서 제외 될 수 있습니다. ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "item-row" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "name" }, " 2. "),
        /*#__PURE__*/_createElementVNode("div", { class: "content" }, [
          /*#__PURE__*/_createElementVNode("p", null, " 보내주신 종이팩 박스를 검수 후 올바른 방법으로 참여해주신 분들에 한해 리워드를 순차적으로 배송해드릴 예정입니다. "),
          /*#__PURE__*/_createElementVNode("p", { class: "prefix" }, [
            /*#__PURE__*/_createTextVNode(" 수거-검수까지 일정 시간이 소요되어 리워드 배송까지 최대 2주~1달 정도 소요될 수 있습니다. "),
            /*#__PURE__*/_createElementVNode("br"),
            /*#__PURE__*/_createTextVNode(" ※ 캠페인 운영 과정에서 일정이 변경될 수 있습니다. ")
          ])
        ])
      ])
    ])
  ])
], -1)

import { ref } from 'vue';
import './dialog.scss';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const dialogVisible = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(_component_AppDialog, {
      visible: dialogVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
      class: "ssg-dialog ssg-dialog-faq",
      btns: [],
      title: "FAQ"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})